import React from 'react';
import { Layout } from 'antd';
import { withTranslation } from 'react-i18next';
import { NAMESPACES } from '../../i18n';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { SearchFilters } from '../../forms';
import { MarketParticipantsSearchResults } from '../../components';
import {
  getLegalEntitiesSearchResults,
  getLegalEntitiesSearchResultsData,
} from '../../reducers/searchLegalEntitiesReducer';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import {
  fetchSearchLegalEntities,
  fetchLoginAsCompanyByAdmin,
} from '../../actions/actionCreators/searchLegalEntitiesActionCreators';

const { Content } = Layout;

class MarketParticipants extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    searchLegalEntities: PropTypes.func.isRequired,
    loginByCompanyAsAdmin: PropTypes.func.isRequired,
    searchResults: PropTypes.object.isRequired,
    searchResultsData: PropTypesImmutable.list.isRequired,
    loading: PropTypes.bool.isRequired,
    selectUserMandate: PropTypes.func,
  };

  componentDidMount = () => this.props.searchLegalEntities();

  render() {
    const {
      t,
      searchResultsData,
      searchResults,
      searchLegalEntities,
      loginByCompanyAsAdmin,
      loading,
    } = this.props;

    return (
      <Content>
        <h2 className="main-header">{t('market_participants')}</h2>
        <SearchFilters t={t} searchLegalEntities={searchLegalEntities} />
        <MarketParticipantsSearchResults
          t={t}
          searchLegalEntities={searchLegalEntities}
          searchResults={searchResultsData.toJS()}
          loginByCompanyAsAdmin={loginByCompanyAsAdmin}
          loading={loading}
          {...searchResults.toJS()}
        />
      </Content>
    );
  }
}

const mapStateToProps = (state) => ({
  searchResultsData: getLegalEntitiesSearchResultsData(state),
  searchResults: getLegalEntitiesSearchResults(state),
  loading: getLoadingSelector(getLegalEntitiesSearchResults)(state),
});

const mapDispatchToProps = {
  searchLegalEntities: fetchSearchLegalEntities,
  loginByCompanyAsAdmin: fetchLoginAsCompanyByAdmin,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(NAMESPACES.dashboard)(MarketParticipants));
